import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { PORTAL_ROOT_ID } from "@consts";
interface PortalProps {
  children?: ReactNode;
}

const Portal = ({ children }: PortalProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    return () => setMounted(false);
  }, []);

  return mounted
    ? createPortal(children, document.querySelector(`#${PORTAL_ROOT_ID}`) as HTMLElement)
    : null;
};

export default Portal;